import { Stack } from '@mantine/core';

const CreateSamplePlanPanel = () => {
  return (
    <Stack
      w={425}
      h="100%"
      p="md"
      style={{
        borderRight: '3px solid var(--mantine-color-grey-7)',
      }}
    >
      test
    </Stack>
  );
};

export default CreateSamplePlanPanel;
